/**
 * MonthlyConsumptionBarChart
 * Consumo mensal por marca (histórico de vendas).
 */

import React, { useMemo, useState } from 'react'
import { BarChart3, Loader2 } from 'lucide-react'
import './MonthlyConsumptionBarChart.css'

function MonthlyConsumptionBarChart({ data, loading = false }) {
  const [hoveredIndex, setHoveredIndex] = useState(null)

  const chart = useMemo(() => {
    if (!data?.months?.length) return null
    const maxQty = Math.max(...data.months.map((m) => m.quantity || 0), 1)
    return {
      months: data.months.map((m, index) => ({
        ...m,
        index,
        heightPercent: ((m.quantity || 0) / maxQty) * 100
      })),
      maxQty
    }
  }, [data])

  if (loading) {
    return (
      <div className="monthly-consumption-chart monthly-consumption-chart--loading">
        <Loader2 size={20} className="spinning" />
        <span>Carregando consumo...</span>
      </div>
    )
  }

  if (!chart) {
    return (
      <div className="monthly-consumption-chart monthly-consumption-chart--empty">
        <p>Selecione uma marca para ver o consumo mensal</p>
      </div>
    )
  }

  const hovered = hoveredIndex != null ? chart.months[hoveredIndex] : null

  return (
    <div className="monthly-consumption-chart">
      <div className="monthly-consumption-chart-header">
        <h3>
          <BarChart3 size={16} />
          Consumo Mensal
        </h3>
        {data?.brand && <span className="monthly-consumption-chart-brand">{data.brand}</span>}
      </div>

      {hovered && (
        <div className="monthly-consumption-chart-tooltip">
          <strong>{hovered.label}</strong>
          <span>{hovered.quantity} un.</span>
        </div>
      )}

      <div className="monthly-consumption-chart-bars">
        {chart.months.map((month) => (
          <div
            key={month.key}
            className={`monthly-consumption-chart-bar-col${hoveredIndex === month.index ? ' is-hovered' : ''}`}
            onMouseEnter={() => setHoveredIndex(month.index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <div className="monthly-consumption-chart-bar-track">
              <div
                className="monthly-consumption-chart-bar-fill"
                style={{ height: `${month.heightPercent}%` }}
              />
            </div>
            <span className="monthly-consumption-chart-bar-label">{month.label}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default MonthlyConsumptionBarChart
